export const kpiStorageHeader = [
  {
    group: 'Data',
    columns: [
      {
        name: 'Data',
        id: 'data-data',
        show: true
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'empresa-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'CD/Loja',
    columns: [
      {
        name: 'Código',
        id: 'cd-loja-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'cd-loja-nome-id',
        show: false
      },
      {
        name: 'Tipo',
        id: 'cd-loja-tipo-id',
        show: false
      }
    ]
  },
  // {
  //   group: 'Mundo',
  //   columns: [
  //     {
  //       name: 'Nome',
  //       id: 'mundo-nome-id',
  //       show: false
  //     }
  //   ]
  // },

  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Nome',
        id: 'categoria-compacta-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Categoria',
    columns: [
      {
        name: 'Nome',
        id: 'categoria-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Sub Categoria',
    columns: [
      {
        name: 'Código',
        id: 'subcategoria-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'subcategoria-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Gerente',
    columns: [
      {
        name: 'Produto',
        id: 'gerente-produto-id',
        show: false
      }
    ]
  },

  {
    group: 'Status',
    columns: [
      {
        name: 'Nome',
        id: 'status-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Nome',
        id: '',
        show: false
      }
    ]
  },
  {
    group: 'Deposito',
    columns: [
      {
        name: 'Código',
        id: 'deposito-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'deposito-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'ID',
        id: 'fornecedor-id',
        show: false
      },
      {
        name: 'Descrição',
        id: 'fornecedor-descricao-id',
        show: false
      }
    ]
  },
  {
    group: 'Vendas',
    columns: [
      {
        name: 'CMV 4M',
        id: 'dcmv-4m',
        show: true
      },
      {
        name: 'CMV Real',
        id: 'dcmv-real',
        show: true
      },

      {
        name: 'CMV Projetado',
        id: 'vendas-projetado',
        show: true
      }
    ]
  },

  {
    group: 'Estoque (R$)',
    columns: [
      {
        name: 'Atual',
        id: 'valor-estoque-atual-id',
        show: true
      },
      {
        name: 'Trânsito Compra',
        id: 'valor-estoque-transito-id',
        show: true
      },
      {
        name: 'Trânsito Transferencia',
        id: 'valor-estoque-transito-trans-id',
        show: true
      },
      {
        name: 'Reservado',
        id: 'valor-estoque-reservado-id',
        show: true
      },
      {
        name: 'Deposito 16',
        id: 'valor-estoque-dep16',
        show: true
      },
      {
        name: 'Outros',
        id: 'valor-estoque-outros',
        show: true
      }
      // {
      //   name: 'Excesso',
      //   id: 'valor-estoque-excesso-id',
      //   show: true
      // },
      // {
      //   name: 'Falta',
      //   id: 'valor-estoque-falta-id',
      //   show: true
      // }
    ]
  },
  {
    group: 'Estoque (Dias)',
    columns: [
      {
        name: 'Atual',
        id: 'dias-estoque-atual-id',
        show: true
      },
      {
        name: 'Trânsito Compra',
        id: 'dias-estoque-transito-id',
        show: true
      },
      {
        name: 'Trânsito Transferencia',
        id: 'dias-estoque-transito-trans-id',
        show: true
      },
      // {
      //   name: 'Reservado',
      //   id: 'dias-estoque-reservado-id',
      //   show: true
      // },
      // {
      //   name: 'Excesso',
      //   id: 'dias-estoque-excesso-id',
      //   show: true
      // },
      // {
      //   name: 'Falta',
      //   id: 'dias-estoque-falta-id',
      //   show: true
      // },
      {
        name: 'Total',
        id: 'dias-estoque-total',
        show: true
      }
    ]
  },
  // {
  //   group: 'Ruptura 0 Dias',
  //   columns: [
  //     {
  //       name: 'Num SKUs-Centros',
  //       id: 'ruptura-num-sku-id',
  //       show: true
  //     },
  //     {
  //       name: 'Ruptura (%)',
  //       id: 'ruptura-porcentagem-id',
  //       show: true
  //     }
  //   ]
  // },
  {
    group: 'Sortimento',
    columns: [
      {
        name: 'Posição',
        id: 'sontimento-position',
        show: true
      },
      {
        name: 'Ruptura',
        id: 'sontimento-ruptura',
        show: true
      },
      {
        name: 'Ruptura %',
        id: 'sontimento-ruptura-percent',
        show: true
      }
    ]
  }
]
